import PropTypes from 'prop-types';
import React from 'react';

import Stepper from '../../../gd-components/stepper/stepper.jsx';

import Classes from 'classnames';

class StepperFormElement extends React.Component {
    static propTypes = {
        form: PropTypes.object.isRequired,
        name: PropTypes.string.isRequired,
        minValue: PropTypes.number,
        maxValue: PropTypes.number,
        onChange: PropTypes.func
    };

    UNSAFE_componentWillMount() {
        this.props.form.registerFormComponent(this.props.name,this);
    }

    onChange = (newValue) => {
        const { form, name, onChange } = this.props;
        form.onFormComponentValueChange(name,newValue);
        if (onChange) onChange(newValue);
    };

    render() {
        const { form, name, minValue, maxValue, className } = this.props;
        let value = form.getValue(name);
        const classes = Classes("form-element-stepper", className);

        return <Stepper className={classes}
                        value={value ? value : 0}
                        minValue={minValue}
                        maxValue={maxValue}
                        onChange={this.onChange}/>;
    }
}

module.exports = StepperFormElement;